import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Button from "../../componentes/button/button";
import DropDown from "../../componentes/dropdown/dropdown";
import FaltaService from "../../services/resource/FaltaService";


function FaltasImport({ onSuccess, filiais, idFilial, perfis }) {

    const faltaService = new FaltaService();

    const [file, setFile] = useState(null);
    const [filialId, setFilialId] = useState(idFilial);
    const [dataOperacao, setDataOperacao] = useState("");
    const [loading, setLoading] = useState(false);
    const [formKey, setFormKey] = useState(0);


    const handleUpload = async () => {

        if (!file) {
            toast.warning("Anexe a planilha.");
            return;
        } else if (!filialId) {
            toast.warning("Preencha a Filial");
            return;
        } 

        setLoading(true);

        const formData = new FormData();
        formData.append("file", file);
        formData.append("filialId", filialId);

        try {
            const cargaResponse = await faltaService.importarExcel(formData);

            toast.success("Importação concluída!");

            onSuccess?.();
        } catch (e) {
            toast.error("Erro durante a importação.");
        } finally {
            setFormKey(prev => prev + 1);
            setLoading(false);
        }
    };

    return (
        <div className="flex flex-col ">

            {/* LADO ESQUERDO - FORM */}
            <div key={formKey} className="p-6 space-y-5">

                <DropDown
                    label="Filial"
                    name="filialId"
                    options={filiais}
                    optionLabel="nome"
                    optionValue="id"
                    nullValue
                    filter={false}
                    value={filialId}
                    onChange={(e) => setFilialId(e.target.value)}
                />

                <div className="flex flex-col gap-1.5">
                    <label className="text-sm font-medium text-foreground/80">Arquivo de Faltas</label>
                    <input
                        type="file"
                        label="Planilha (.xlsx)"
                        accept=".xlsx,.xls, .xlsm"
                        onChange={(e) => setFile(e.target.files[0])}
                        className="border border-input rounded-md w-full px-3 py-2 text-sm transition-colors duration-150 focus:outline-none focus:border-primary focus:ring-2 focus:ring-primary/15"
                    />
                </div>

                <Button
                    onClick={handleUpload}
                    disabled={loading}
                    label={loading ? "Importando..." : "Confirmar Importação"}
                    loading={loading}
                    iconLeft="fa fa-upload"
                />
            </div>


        </div>
    );
}

export default FaltasImport;